<label [for]="labelName" class="soft-checkbox flex justify-center items-center w-full">
  @if (labelPosition === 'before') {
    <ng-content></ng-content>
    }
    <span
      class="soft-checkbox-box absolute"
      [class.checked]="checked"
      [class.readonly]="readonly || parentReadonly"
      [class.disabled]="disabled"
      [class.focus]="hasFocus.hasFocus"
    ></span>
    @if (checked) {
      <i
        class="fa-regular fa-check soft-checkbox-indicator pt-[1px] pl-[1px] z-10"
        aria-hidden="true"
      ></i>
    }

    <input
      [id]="labelName"
      class="soft-checkbox-input"
      type="checkbox"
      [checked]="checked"
    (change)="
      !disabled && !readonly && !parentReadonly ? setChecked(input.checked) : undefined
    "
      [readOnly]="readonly || parentReadonly"
      [disabled]="disabled"
      #hasFocus="softHasFocus"
      softHasFocus
      #input
      />
    @if (labelPosition === 'after') {
      <ng-content></ng-content>
    }
  </label>
